import { useTranslation } from 'react-i18next'

import Text from '@/components/atomic/atoms/Text'
import Section from '@/components/atomic/molecules/Section'
import TagList from '@/components/atomic/organisms/TagList'
import { HospitalView } from '@/features/hospital/types/hospital.type'

interface CreditCardSectionProps {
  hospital: HospitalView
}

export const HospitalCreditCardSection = ({ hospital }: CreditCardSectionProps) => {
  const { t } = useTranslation()

  return (
    <Section title={t('templates.hospitalDetail.creditCardTitle')}>
      <TagList tags={hospital.payment.creditCards?.names || []} />
      {hospital.payment.creditCards?.comment && (
        <Text element="p" type="caption2">
          {hospital.payment.creditCards?.comment}
        </Text>
      )}
    </Section>
  )
}
